/**
 * Blog Ajax Functionality
 * Handles category filtering and load more posts functionality
 */

const initBlogAjax = () => {
    if (!window.jQuery || typeof ajax_object === 'undefined') {
        console.warn('Blog Ajax: jQuery or ajax_object not available');
        return;
    }

    const $ = jQuery;

    // Category Filter Click
    $('.category-filter').on('click', function (e) {
        e.preventDefault();

        const $button = $(this);
        const category = $button.data('category');

        // Update active state
        $('.category-filter').removeClass('active');
        $button.addClass('active');

        // Show loading state
        const $container = $('#blog-posts-container');
        $container.html('<div class="text-center py-5"><div class="spinner-border text-primary" role="status"><span class="visually-hidden">Loading...</span></div></div>');

        // Ajax request
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'filter_blog_posts',
                category: category,
                page: 1,
                nonce: ajax_object.nonce
            },
            success: function (response) {
                if (response.success) {
                    $container.html(response.data.html);

                    // Update load more button
                    const $loadMoreBtn = $('#load-more-posts');
                    if (response.data.max_pages > 1) {
                        $loadMoreBtn.attr('data-page', '1')
                            .attr('data-max-pages', response.data.max_pages)
                            .attr('data-category', category)
                            .show();
                    } else {
                        $loadMoreBtn.hide();
                    }

                    // Update URL without page reload
                    const url = category > 0 ?
                        window.location.pathname + '?cat=' + category :
                        window.location.pathname;
                    history.pushState(null, '', url);
                }
            },
            error: function () {
                $container.html('<div class="alert alert-danger text-center">Error loading posts. Please try again.</div>');
            }
        });
    });

    // Load More Click
    $(document).on('click', '#load-more-posts', function (e) {
        e.preventDefault();

        const $button = $(this);
        const currentPage = parseInt($button.data('page'));
        const maxPages = parseInt($button.data('max-pages'));
        const category = $button.data('category');
        const nextPage = currentPage + 1;

        // Show loading state
        $button.prop('disabled', true);
        $('.load-more-text').addClass('d-none');
        $('.load-more-spinner').removeClass('d-none');

        // Ajax request
        $.ajax({
            url: ajax_object.ajax_url,
            type: 'POST',
            data: {
                action: 'load_more_blog_posts',
                category: category,
                page: nextPage,
                nonce: ajax_object.nonce
            },
            success: function (response) {
                if (response.success) {
                    // Append new posts
                    $('#blog-posts-container .row').append(response.data.html);

                    // Update button state
                    $button.data('page', nextPage);

                    // Hide button if no more pages
                    if (nextPage >= maxPages) {
                        $button.hide();
                    }
                }
            },
            error: function () {
                alert('Error loading more posts. Please try again.');
            },
            complete: function () {
                // Reset loading state
                $button.prop('disabled', false);
                $('.load-more-text').removeClass('d-none');
                $('.load-more-spinner').addClass('d-none');
            }
        });
    });
};

export default initBlogAjax;